// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"card-results_uk-open__AORDQ","grecaptcha-badge":"card-results_grecaptcha-badge__v9aWf","grid":"card-results_grid__YTpHn","four":"card-results_four__q9uAJ","isOpen":"card-results_isOpen__42axo","toggleView":"card-results_toggleView__8JDg3","icon":"card-results_icon__8PvZM","open":"card-results_open__7RRSk"};
    if(module.hot) {
      // 1793877038432
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  